
import XHeader from 'vux/src/components/x-header/index.vue'

import Group from 'vux/src/components/group/index.vue'

import Cell from 'vux/src/components/cell/index.vue'

import XButton from 'vux/src/components/x-button/index.vue'

import Divider from 'vux/src/components/divider/index.vue'

import InfiniteLoading from 'vue-infinite-loading';

export default {
components: {
XHeader,
Group,
Cell,
XButton,
Divider,
InfiniteLoading
},
data() {
return {

balanceList: [],

currentPage: 1
}
},
methods: {
infiniteHandler($state) {
const url = this.tianYiWebUrl + '/wechat/uc/ajaxGetBalanceList'
this.$http.get(url, {params: {page: this.currentPage}}).then(r => {
const res = r.data
if (res.code === 200) {
this.balanceList = [...this.balanceList, ...res.data.data]
if (res.data.total > res.data.per_page * res.data.current_page) {
this.currentPage++
$state.loaded()
} else {
$state.complete();
}
}
})
}
},

created: function () {
document.title='账户流水'
},
mounted: function () {
},
}



// WEBPACK FOOTER //
// ./src/components/uc/Balance.vue